import React from "react"
import Link from "../../Link"
import HTMLReactParser from "html-react-parser"

import { createUseStyles } from "react-jss"
import styles from "./styles"

import Arrow from "../svgs/Arrow"
/* eslint-disable */

export default function Button({
  link,
  text,
  buttonStyle,
  colour,
  button = false,
  type = "button",
  disabled = false,
}) {
  let overrides = {
    colour: colour,
  }
  const useStyles = createUseStyles(styles({ overrides }))
  const classes = useStyles()

  if (button) {
    return (
      <button
        className={`button inline-block px-6 py-3 text-white bg-gold text-lg hover:bg-gold-dark transition-transform duration-300 transform uppercase font-thin`}
        type={type}
        disabled={disabled}
      >
        <span className="text">{HTMLReactParser(text)}</span>
      </button>
    )
  }

  return (
    <Link
      className={`button ${classes.button} ${buttonStyle} ${colour}`}
      to={link.replace(process.env.GATSBY_FRONTEND_URL, "")}
    >
      {buttonStyle !== "tertiary" && (
        <span className="icon">
          <Arrow />
        </span>
      )}
      <span className="text">{HTMLReactParser(text)}</span>
    </Link>
  )
}
